// 配置API接口地址
var root = '/api'

// 引用axios
var axios = require('axios')
var qs = require('qs')
var md5 = require('js-md5')

// 自定义判断元素类型JS
function toType (obj) {
  return ({}).toString.call(obj).match(/\s([a-zA-Z]+)/)[1].toLowerCase()
}

// 参数过滤函数
function filterNull (o) {
  for (var key in o) {
    if (o[key] === null) {
      delete o[key]
    }
    if (toType(o[key]) === 'string') {
      o[key] = o[key].trim()
    } else if (toType(o[key]) === 'object') {
      o[key] = filterNull(o[key])
    } else if (toType(o[key]) === 'array') {
      o[key] = filterNull(o[key])
    }
  }
  return o
}

// 加密
function getSign(obj,method,stime) {
    let objs = [];
    if(obj == null){
        objs = [];
    }else if(method == 'POST' && !(obj instanceof FormData)){
        objs = {...obj.data};
    }else if(obj instanceof FormData){//对于formData数据拆分
        let obj1 = {};
        for(var pair of obj.entries()) {
            if(pair[0].indexOf('data') != -1){
                let pairs = pair[0].split('[');
                pairs = pairs[1].split(']')[0];
                obj1[pairs] = pair[1];
            }
        }
        objs = obj1;
    }else if(method == 'GET'){
        objs = {...obj};
    }
	let secret = 'g1YoVCkanMOH6vrU';
    objs['secret'] = secret;
    objs['stime'] = stime;
    let newkey = Object.keys(objs).sort();
    let sign = '';
    for (var i = 0; i < newkey.length; i++) {
        let value = objs[newkey[i]];
        if(typeof(value) != 'object' && value != undefined){
            if(sign.length) {
                sign += '&'+newkey[i]+'='+value;
            } else {
                sign = newkey[i]+'='+value;
            }
        }
    }
    let signs = md5(sign);
	return [sign,signs];
}

// 取cookie
function getCookie(cookieName){
    var cookieStr = unescape(document.cookie);
    var arr = cookieStr.split("; ");
    var cookieValue = "";
    for(var i=0;i<arr.length;i++){
        var temp = arr[i].split("=");
        if(temp[0]==cookieName){
            cookieValue = temp[1];
            break;
        }
    }
    return cookieValue;
}

function apiAxios (method, url, params, success, failure) {
    let stime = Math.floor((new Date()).getTime()/1000);
    let cooke = document.cookie.indexOf("xiaohuozi");
    let authoriZation = '';
    if(cooke != -1){
        authoriZation = getCookie('xiaohuozi');
    }else{
        authoriZation = sessionStorage.getItem('xiaohuozi');
    }
    let sign = getSign(params,method,stime)[0];
    let signs = getSign(params,method,stime)[1];
    if (params) {
        params = filterNull(params)
    }
    if(method == 'POST' && !(params instanceof FormData)){
        params = qs.stringify(params);//数据参数格式转换
    }
    axios({
        method: method,
        url: url,
        data: method === 'POST' || method === 'PUT' ? params : null,
        params: method === 'GET' || method === 'DELETE' ? params : null,
        baseURL: root,
        headers:{'sign':signs,'stime':stime,'Authorization':authoriZation},
        withCredentials: false
    })
    .then(function (res) {
      // console.log('success', res)
        if (res.data) {
            if (success) {
                success(res.data)
            }
        } else {
            if (failure) {
                failure(res.data)
            } else {
                // window.alert('error: ' + JSON.stringify(res.data))
            }
        }
    })
    .catch(function (err) {
        let res = err.response
        if (err) {
            if(res){
                failure(res)
            }
        }
    })
}

//返回在vue模板中的调用接口
export default {
  get: function (url, params, success, failure) {
    return apiAxios('GET', url, params, success, failure)
  },
  post: function (url, params, success, failure) {
    return apiAxios('POST', url, params, success, failure)
  },
  put: function (url, params, success, failure) {
    return apiAxios('PUT', url, params, success, failure)
  },
  delete: function (url, params, success, failure) {
    return apiAxios('DELETE', url, params, success, failure)
  }
}



// WEBPACK FOOTER //
// ./src/api/index.js